import Head from 'next/head';

import { BRANCH_KEY } from '@utils/constants';

/**
 * GTM, Facebook Pixel, Branch
 */
export const TrackingScript: React.FC = () => (
  <>
    <Head>
      <script
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-TGPFDSF');
						`,
        }}
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `
            !function (f, b, e, v, n, t, s) {
              if (f.fbq) return; n = f.fbq = function () {
              n.callMethod ?
                n.callMethod.apply(n, arguments) : n.queue.push(arguments)
              }; if (!f._fbq) f._fbq = n;
              n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0;
              t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s)
            }(window,
              document, 'script', '//connect.facebook.net/en_US/fbevents.js');
            fbq('init', '118232541880225');
            fbq('track', 'PageView');
            function fbqSearchKeyword() {
              var uri = document.referrer;
              if (!uri) return;
              var link = document.createElement('a');
              link.setAttribute('href', uri);
              var pattern = new RegExp('[\\\\?&](?:q|query)=([^&#]*)');
              var query = link.search.match(pattern);
              if (query && query.length > 0) {
              var keyword = query[1].replace(/\\+/gi, "%20");
              }
              if (keyword) {
              fbq('trackCustom', 'SearchKeyword', {
                hostname: link.hostname,
                keyword: decodeURIComponent(keyword),
              });
              }
            }
            fbqSearchKeyword();
            (function(b,r,a,n,c,h,_,s,d,k){if(!b[n]||!b[n]._q){for(;s<_.length;)c(h,_[s++]);d=r.createElement(a);d.async=1;d.src="https://cdn.branch.io/branch-latest.min.js";k=r.getElementsByTagName(a)[0];k.parentNode.insertBefore(d,k);b[n]=h}})(window,document,"script","branch",function(b,r){b[r]=function(){b._q.push([r,arguments])}},{_q:[],_v:1},"addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent logEvent disableTracking".split(" "), 0);
            branch.init('${BRANCH_KEY}');
    `,
        }}
      />
    </Head>
    <noscript>
      <iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-TGPFDSF"
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
      />
    </noscript>
    <script
      dangerouslySetInnerHTML={{
        __html: `window._vwo_code = window._vwo_code || (function(){
						var account_id=331312,
						settings_tolerance=2000,
						library_tolerance=2500,
						use_existing_jquery=false,
						is_spa=1,
						hide_element='body',
								
						/* DO NOT EDIT BELOW THIS LINE */
						f=false,d=document,code={use_existing_jquery:function(){return use_existing_jquery;},library_tolerance:function(){return library_tolerance;},finish:function(){if(!f){f=true;var a=d.getElementById('_vis_opt_path_hides');if(a)a.parentNode.removeChild(a);}},finished:function(){return f;},load:function(a){var b=d.createElement('script');b.src=a;b.type='text/javascript';b.innerText;b.onerror=function(){_vwo_code.finish();};d.getElementsByTagName('head')[0].appendChild(b);},init:function(){
						window.settings_timer=setTimeout(function () {_vwo_code.finish() },settings_tolerance);var a=d.createElement('style'),b=hide_element?hide_element+'{opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;}':'',h=d.getElementsByTagName('head')[0];a.setAttribute('id','_vis_opt_path_hides');a.setAttribute('type','text/css');if(a.styleSheet)a.styleSheet.cssText=b;else a.appendChild(d.createTextNode(b));h.appendChild(a);this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&f='+(+is_spa)+'&r='+Math.random());return settings_timer; }};window._vwo_settings_timer = code.init(); return code; }());`,
      }}
    />
  </>
);
